import {
    getResource,
    listResources,
    multiGetResources,
    ResourceCategory,
    type ListResourcesOptions,
    type ResourceId,
} from '@wwf/sdk';
import type { DataProvider, GetListParams } from 'react-admin';
import { toHttpError } from '@core/api';
import { toListParams, toRecord } from '../utils';

export const ragResourceProvider: Partial<DataProvider> = {
    getList: async (_resource, params) => {
        try {
            const listParams = toListParams(
                params as GetListParams
            ) as ListResourcesOptions;
            const page = await listResources({
                ...listParams,
                filter: {
                    ...listParams.filter,
                    category: ResourceCategory.documentation,
                },
            });
            return {
                data: page.content.map(toRecord) as any[],
                total: page.totalElements,
            };
        } catch (e) {
            throw toHttpError(e);
        }
    },

    getOne: async (_resource, params) => {
        try {
            const data = await getResource(params.id as ResourceId);
            return { data: toRecord(data) as any };
        } catch (e) {
            throw toHttpError(e);
        }
    },

    getMany: async (_resource, params) => {
        try {
            const data = await multiGetResources(params.ids as ResourceId[]);
            return { data: data.map(toRecord) as any[] };
        } catch (e) {
            throw toHttpError(e);
        }
    },
};
